import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { useAppDependencies } from "../../context/AppContext"
import Layout from "../Layout"
import SearchPage from "../search/SearchPage"
import ContactUsPage from "../general/ContactUsPage"
import TermsOfUsePage from "../general/TermsOfUsePage"
import SaleEnquiryPage from "../general/SaleEnquiryPage"
import SavedValuationsPage from "../valuations/SavedValuationsPage"
import ValuationPageServer from "../valuations/ValuationPageServer"
import AreaSearchPage from "../search/AreaSearchPage"
import AreaAnalysisPageServer from "../areas/AreaAnalysisPageServer"
import PremiumPage from "../premium/PremiumPage"
import OldUrlRedirect from "./OldUrlRedirect"
import ParamParser from "../../navigation/ParamParser"
import StateConstants from "../../states/StateContstants"
import PathRouter from "../../navigation/PathRouter"

// Home/Search Page
export function HomePageWrapper() {
    const deps = useAppDependencies()
    return (
        <Layout>
            <SearchPage
                stateHandler={deps.stateHandler}
                apiHandler={deps.apiHandler}
                errorHandler={deps.errorHandler}
                loader={deps.loader}
            />
        </Layout>
    )
}

// Login Page — opens modal on home page instead of dedicated page
export function LoginPageWrapper() {
    const deps = useAppDependencies()
    useEffect(() => {
        deps.stateHandler.set(StateConstants.SHOW_LOGIN_MODAL, true)
    }, [])
    return (
        <Layout>
            <SearchPage
                stateHandler={deps.stateHandler}
                apiHandler={deps.apiHandler}
                errorHandler={deps.errorHandler}
                loader={deps.loader}
            />
        </Layout>
    )
}

// Contact Page
export function ContactPageWrapper() {
    return (
        <Layout>
            <ContactUsPage />
        </Layout>
    )
}

// Terms Page
export function TermsPageWrapper() {
    return (
        <Layout>
            <TermsOfUsePage />
        </Layout>
    )
}

// Sell My Home Page
export function SellMyHomePageWrapper() {
    const [searchParams] = useSearchParams()
    const address = searchParams.get(PathRouter.ADDRESS_PARAM) || ""
    const deps = useAppDependencies()

    return (
        <Layout>
            <SaleEnquiryPage
                apiHandler={deps.apiHandler}
                loader={deps.loader}
                errorHandler={deps.errorHandler}
                stateHandler={deps.stateHandler}
                enquiryType="SALE"
                initialAddress={address}
            />
        </Layout>
    )
}

// Get Valuation Page
export function GetValuationPageWrapper() {
    const [searchParams] = useSearchParams()
    const address = searchParams.get(PathRouter.ADDRESS_PARAM) || ""
    const deps = useAppDependencies()

    return (
        <Layout>
            <SaleEnquiryPage
                apiHandler={deps.apiHandler}
                loader={deps.loader}
                errorHandler={deps.errorHandler}
                stateHandler={deps.stateHandler}
                enquiryType="VALUATION"
                initialAddress={address}
            />
        </Layout>
    )
}

// Saved Valuations Page
export function SavedValuationsPageWrapper() {
    const deps = useAppDependencies()
    return (
        <Layout>
            <SavedValuationsPage
                apiHandler={deps.apiHandler}
                stateHandler={deps.stateHandler}
                errorHandler={deps.errorHandler}
                loader={deps.loader}
                loginHelper={deps.loginHelper}
            />
        </Layout>
    )
}

// Area Search Page
export function AreaSearchPageWrapper() {
    const deps = useAppDependencies()
    return (
        <Layout>
            <AreaSearchPage
                stateHandler={deps.stateHandler}
                apiHandler={deps.apiHandler}
                errorHandler={deps.errorHandler}
                loader={deps.loader}
            />
        </Layout>
    )
}

// Area Analysis Page (with slug redirect)
export function AreaAnalysisPageWrapper() {
    const deps = useAppDependencies()
    return (
        <Layout>
            <AreaAnalysisPageServer
                stateHandler={deps.stateHandler}
                apiHandler={deps.apiHandler}
                errorHandler={deps.errorHandler}
                loader={deps.loader}
                areaAnalysisBuilderChain={deps.areaAnalysisBuilderChain}
            />
        </Layout>
    )
}

// Valuation Page (with address slug)
export function ValuationPageWrapper() {
    const deps = useAppDependencies()
    return (
        <Layout>
            <ValuationPageServer
                stateHandler={deps.stateHandler}
                apiHandler={deps.apiHandler}
                errorHandler={deps.errorHandler}
                loader={deps.loader}
                loginHelper={deps.loginHelper}
                featureProvider={deps.featureProvider}
            />
        </Layout>
    )
}

// Valuation Page (without address slug - fallback)
export function ValuationPageWithoutSlugWrapper() {
    const deps = useAppDependencies()
    return (
        <Layout>
            <ValuationPageServer
                stateHandler={deps.stateHandler}
                apiHandler={deps.apiHandler}
                errorHandler={deps.errorHandler}
                loader={deps.loader}
                loginHelper={deps.loginHelper}
                featureProvider={deps.featureProvider}
            />
        </Layout>
    )
}

// Premium Page
export function PremiumPageWrapper() {
    const deps = useAppDependencies()
    return (
        <Layout>
            <PremiumPage
                stateHandler={deps.stateHandler}
                apiHandler={deps.apiHandler}
            />
        </Layout>
    )
}

// Old URL Redirect Handler
export function OldUrlRedirectWrapper() {
    return <OldUrlRedirect />
}

